import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import queryString from 'query-string';

import { Logger } from 'wtb-utils';
import {
  useAuthContext,
  useTransactionContext
} from 'context';
import {
  AUTOGIRO_STEPS,
  BETALINGSSERVICE_STEPS,
  PAYMENT_TYPES,
  SEPA_STEPS
} from 'constants.js';

const AccountAuth = () => {
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();

  const {
    authToken,
    setAuthToken,
    authProvider,
    setAuthSessionId,
    setPreselectedAccount
  } = useAuthContext();
  const { selectedPaymentPlan } = useTransactionContext();

  let paymentSteps;
  switch (selectedPaymentPlan.type) {
    case PAYMENT_TYPES.SEPA:
      paymentSteps = SEPA_STEPS;
      break;
    case PAYMENT_TYPES.AUTOGIRO:
      paymentSteps = AUTOGIRO_STEPS;
      break;
    case PAYMENT_TYPES.BETALINGSSERVICE:
      paymentSteps = BETALINGSSERVICE_STEPS;
      break;
    default:
      Logger.error('Unsupported payment type to define payment steps');
      break;
  }

  const [ initialized, setInitialized ] = useState(false);

  const query = queryString.parse(location.search);

  useEffect(() => {
    setAuthToken(query.authorizationId);
    setAuthSessionId(query.sessionId);
    setPreselectedAccount(query.verifiedAccountId);

    setInitialized(true);
  }, [ query, authProvider, setAuthToken, setAuthSessionId, setPreselectedAccount ]);

  useEffect(() => {
    if (!initialized) return;

    const { result, error } = query;
    if (authToken && result === 'success') {
      history.push(`/${id}/payment/${PAYMENT_TYPES[selectedPaymentPlan.type].toLowerCase()}/${paymentSteps.CONNECTING_BANK}`);
    } else if (result === 'canceled' || error) {
      history.push(`/${id}/account-authorization/retry`);
    } else {
      history.push(`/${id}/payment/${PAYMENT_TYPES[selectedPaymentPlan.type].toLowerCase()}/${paymentSteps.ADD_BANK_ACCOUNT}`);
    }
  }, [
    initialized,
    id,
    authProvider,
    authToken,
    query,
    history,
    paymentSteps.CONNECTING_BANK,
    paymentSteps.ADD_BANK_ACCOUNT,
    selectedPaymentPlan.type
  ]);

  return <div />;
};

export default AccountAuth;
